import React from "react";
import { FaWhatsapp } from "react-icons/fa"; 

const EnquiryForm = () => {
  // Smooth scroll handler
 

  return (
    <div>

         <br />
           <div className="text-center">


             <a
              href={`https://wa.me/919356411908?text=Hi, I'm interested in booking a cab with eTravo.`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
              style={{
                ...styles.button,
                backgroundColor: "#008000",
                marginTop: "12px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center", margin: "30px 0",
                
                gap: "8px",
                textDecoration: "none",
              }}
            >
              <FaWhatsapp className="text-white" /> Chat on WhatsApp
            </a>
           </div>
      {/* Book Now Button */}
     
      {/* Enquiry Form */}
      <div id="enquiry-form" style={styles.container}>
        <h2 style={styles.title}>Send Your Enquiry</h2>
        <form
          action="https://formsubmit.co/sales@etravo.in"
          method="POST"
          style={styles.form}
        >
          <div style={styles.grid}>
            <input type="text" name="name" placeholder="Enter Your Name" style={styles.input} required />
            <input type="email" name="email" placeholder="Enter Email ID" style={styles.input} required />
            <input type="tel" name="phone" placeholder="+91 Phone No" style={styles.input} required />
            <input type="text" name="pickupCity" placeholder="Enter Pickup City" style={styles.input} required />
            <select name="vehicle" style={styles.input} required>
              <option value="">Select Vehicle</option>
              <option value="Sedan">Sedan</option>
              <option value="SUV">SUV</option>
              <option value="Innova Crysta">Innova Crysta</option>
              <option value="Tempo Traveller">Tempo Traveller</option>
            </select>
            <input type="date" name="date" style={styles.input} required />
            <input type="number" name="travelers" placeholder="No. of Travelers" style={styles.input} required />
            <select name="purpose" style={styles.input} required>
              <option value="">Select Rental Purpose</option>
              <option value="Airport Transfer">Airport Transfer</option>
              <option value="Wedding">Wedding</option>
              <option value="Corporate">Corporate</option>
              <option value="Outstation Trip">Outstation Trip</option>
            </select>
            <textarea
              name="requirements"
              placeholder="Enter Requirement Details"
              rows="2"
              style={styles.textarea}
            ></textarea>
          </div>

          {/* Hidden Redirect Fields */}
          <input type="hidden" name="_next" value="https://etravo.in/thank-you" />
          <input type="hidden" name="_captcha" value="false" />

          {/* Terms Agreement */}
          <div style={styles.agreement}>
            <input type="checkbox" name="agree" required />
            <span>
              By clicking "Send Enquiry", you agree to our{" "}
              <a href="#" style={styles.link}>Terms & Conditions</a> and{" "}
              <a href="#" style={styles.link}>Privacy Policy</a>.
            </span>
          </div>

          {/* Submit and WhatsApp */}
          <div style={{ textAlign: "center" }}>
            <button type="submit" style={styles.button}>Send Enquiry</button>
         
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1000px",
    margin: "40px auto",
    background: "#fff",
    borderRadius: "12px",
    padding: "30px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    fontFamily: "'Roboto', sans-serif",
  },
  title: {
    color: "#096C05",
    textAlign: "center",
    marginBottom: "24px",
  },
  form: {
    width: "100%",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "2px solid #096C05",
    outline: "none",
  },
  textarea: {
    padding: "12px",
    borderRadius: "8px",
    border: "2px solid #096C05",
    resize: "vertical",
    outline: "none",
  },
  agreement: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    fontSize: "14px",
    color: "#333",
    margin: "20px 0",
  },
  link: {
    color: "#096C05",
    textDecoration: "none",
  },
  button: {
    backgroundColor: "#096C05",
    color: "#fff",
    padding: "12px 30px",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s ease",
  },
};

export default EnquiryForm;
